var map = {
	"./Creamos_en_Mexico.png": "f4e5",
	"./FDA.png": "9d73",
	"./certification-comercam.png": "768d",
	"./certification-denominacion.png": "8f44",
	"./certification-hecho.png": "7e01",
	"./certification-kosher.png": "0bbe",
	"./certification-nom.png": "8576",
	"./comercam-mezcal.jpg": "ffc2",
	"./galardon1.png": "a022",
	"./logo_esr.png": "9316"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dcc0";